/** Janela após a última movimentação em que o app ainda conta como sob carga do Feed Link. */
const ACTIVITY_WINDOW_MS = 30_000;

let lastActivityAt = 0;

/** Registra que o Feed Link acabou de mexer: arquivo entrando na fila ou linha sendo processada. */
export function markFeedLinkActivity() {
  lastActivityAt = Date.now();
}

/** Se o Feed Link mexeu há pouco; quem mede latência do app evita medir sob essa carga. */
export function isFeedLinkActive() {
  return Date.now() - lastActivityAt < ACTIVITY_WINDOW_MS;
}
